import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActionSheetController, AlertController, NavController, ToastController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { Platform } from '@ionic/angular';
import swal from 'sweetalert'
import * as $ from 'jquery'
import { Observable } from 'rxjs';

import { SuperadminService } from 'src/app/services/superadmin.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { PhotoService } from 'src/app/services/photo.service';
import { GeolocationService } from 'src/app/services/geolocation.service';
declare var google
@Component({
  selector: 'app-super-admin',
  templateUrl: './super-admin.component.html',
  styleUrls: ['./super-admin.component.scss'],
})
export class SuperAdminComponent implements OnInit {
  public foto="assets/img/super_admin.png"
  public nombre
  public usuarios
  public semillas
  public timer='Hoy'
  public timerPedido='Hoy'
  public ventas: any;
  public pedidos
  public solicitud_usuario;
  public valorUnidad
  public valorModulo
  public franja
  public clavePrecios
  public valorUnidadesFranjas
  public activarDesktop=0
  public role
  public useri
  public nombrePais
  public status=1
  public origin
  public map: any;
  constructor(private db:AngularFirestore, 
    private auth:AngularFireAuth,
    private plat:Platform,
    private photo:PhotoService,
    private superadmin:SuperadminService,
    private navCtrl:NavController,
    private tool:ToastController,
    private geo:GeolocationService,
    private notification:NotificationsService,
    private actionSheetController:ActionSheetController,
    private user:AuthService) {
     
      this.plat.ready().then(() => {
        // 'hybrid' detects both Cordova and Capacitor
        if (this.plat.is('desktop')) {
          this.activarDesktop=1
        }
      });
   

      
     }

  ngOnInit() {   
    this.initMap()
    this.traerDataUser()
  }

  ionViewWillEnter(){
   
  }

  
  traerDataUser(){
    this.auth.auth.onAuthStateChanged(k=>{
       this.user.datosPefilSesion(k.uid).subscribe(m=>{
         this.franja=m.data()['pais']
         this.role=m.data()['role']
         console.log(this.role)
         this.foto=m.data()['foto']
         this.traerDatoFranja(this.franja)
         this.traerInformacionTotalPuntos()
         this.traerInformacionTotalUsuarios()
         this.traerInformacionPersonal()
         this.traerVentasTotales()
         this.valorUnidades()
         this.pedidosEntrantes()
         this.traerUsuariosSolicitantes()
         this.traerUsuariosSolicitantesAdministradores()
       })
    })
  }

  traerDatoFranja(i){
    this.db.collection('franjas',ref=>ref.where('name','==',i)).get().subscribe(k=>{
        k.forEach(m=>{
          this.nombrePais=m.data()['country']
        })
    })
  }
/**
 * It gets the user's name from the database.
 */
  traerInformacionPersonal(){
    this.auth.auth.onAuthStateChanged(u=>{
       this.user.datosPefilSesion(u.uid).subscribe(o=>{
            this.nombre=o.data()['nombre']
       })
    })
  }

/**
 * This function is going to get all the documents from the collection called 'usuarios' and then it's
 * going to subscribe to the observable that is returned by the get() function
 */
  traerInformacionTotalUsuarios(){
    this.db.collection('usuarios',ref=>ref.where('pais','==',this.franja)).get().subscribe(m=>{
      this.usuarios=m.size
      console.log(m.docs[0])
    })
  }
/**
 * It gets the number of seeds in the database.
 */
  
  traerInformacionTotalPuntos(){
    this.db.collection('seeds',ref=>ref.where('pais','==',this.franja)).get().subscribe(l=>{
      this.semillas=l.size
      
       
     })
     
   
  }


/**
 * It gets all the documents from the collection 'recaudos' and then it checks if the date of the
 * document is the same as the current date, if it is, it pushes the document to the array 'ventas'
 */

  traerVentasTotales(){
    this.ventas=[]
    var date=new Date().getDate()
    var dateMonth=new Date().getMonth()
    var year= new Date().getFullYear()

    this.db.collection('recaudos',ref=>ref.where('franja','==',this.franja)).get().subscribe(l=>{
     
          l.forEach(u=>{
            if(this.timer=='Hoy'){
              if(new Date(u.data()['fecha']).getDate() == date && new Date(u.data()['fecha']).getDate() == dateMonth && new Date(u.data()['fecha']).getFullYear()==year){
                this.ventas.push(u.data())
                this.timer='Hoy'
                console.log(this.ventas)
              }
            }else if(this.timer=="Mensual"){

               if(new Date(u.data()['fecha']).getMonth() == dateMonth && new Date(u.data()['fecha']).getFullYear()==year){
                this.ventas.push(u.data())
              
                this.timer='Mensual'
          
               }
            }else{
              if(new Date(u.data()['fecha']).getFullYear() == year ){
          
                this.ventas.push(u.data())
              }
            }
            
        })
       
        
    })
  }

 /**
  * It's a function that gets all the documents from the collection 'pedido' and then it filters them
  * by date
  */
  pedidosEntrantes(){
    this.pedidos=[]
    var date=new Date().getDate()
    this.db.collection('pedido').get().subscribe(i=>{
      i.forEach(k=>{

              if( k.data()['estado']=='vigente' && k.data()['franja']==this.franja){
                this.pedidos.push(k.data())
              }
         
      })
     
    })
  }


  formatCOPValue(value) {
    let format = '$ ';
    if (value)
        return (format + value.toLocaleString('es-ES'));

    return `$ 0`;
  }
 

  traerUsuariosSolicitantes(){
    this.solicitud_usuario=[]

      this.db.collection('solicitud_usuario',ref=>ref.where('role','==','3')).get().subscribe(e=>{
        e.forEach(o=>{
          if(o.data()['estado']==0){
            this.solicitud_usuario.push(o.data())
          }
           
        })
      })
  }
  traerUsuariosSolicitantesAdministradores(){
    this.solicitud_usuario=[]
      
      this.db.collection('solicitud_usuario',ref=>ref.where('role','==','1')).get().subscribe(e=>{
        e.forEach(o=>{
          if(o.data()['estado']==0){
            this.solicitud_usuario.push(o.data())
          }
           
        })
      })
  }

  async pedidoOpciones(i){
    var object={
      'obj':i
    }
    this.navCtrl.navigateForward(['/detail-pedido'],{
      queryParams: {
          'service': JSON.stringify(object)
      }
   })
  }
/**
 * It takes a parameter called franja, which is a string, and then it updates the value of the document
 * in the collection preciosGlobales, where the field franja is equal to the value of the parameter
 * franja. 
 * 
 * The function is called when the user clicks on the button "Actualizar" in the page "Precios
 * Globales". 
 * 
 * The function is called with the parameter franja, which is the value of the field franja in the
 * document in the collection preciosGlobales. 
 * 
 * The function updates the value of the fields valorAccesorioGlobal and valorModuloGlobal in the
 * document in the collection preciosGlobales, where the field franja is equal to the value of the
 * parameter franja. 
 * 
 * The function calls the function valorUnidades, which is defined in the same file.
 * @param franja - is the name of the collection
 */

  actualizarPrecios(franja){
    swal({
      title: "¿Estás seguro?",
      text: "Desea Actualizar el Precio del Valor de los productos",
      icon: "warning",
      buttons:['Cancelar','Aceptar'],
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        console.log($('#vauUnidad'+franja).val())
        this.db.collection('preciosGlobales',ref=>ref.where('franja','==',franja)).get().subscribe(p=>{
          p.forEach(k=>{
            k.ref.update({
              'valorAccesorioGlobal':$('#vauUnidad'+franja).val(),
              'valorModuloGlobal':$('#vauModulo'+franja).val()
            }).then(()=>{
              this.valorUnidades()
              this.toastMessage()
            })
          })
        })
     
       

      } else {
        swal("¡Cancelado!");
      }
    });
   
   

  }

  /**
   * It's a function that gets the data from a firestore collection and pushes it into an array
   */
  async valorUnidades(){
    this.valorUnidadesFranjas=[]
   
    this.db.collection('preciosGlobales',ref=>ref.where('franja','==',this.franja)).get().subscribe(l=>{
      l.forEach(k=>{
       this.valorUnidadesFranjas.push(k.data())
      })
    })
  }
  
  async usuarioOpciones(user){
    console.log(user)
    const actionSheet = await this.actionSheetController.create({
      header: 'Opciones',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'Aceptar',
        icon: 'checkmark',
        handler: () => {
          this.darAcceso(user)
        }
      }, 
      {
        text: 'Denegar',
        icon: 'ban',
        handler: () => {
            this.denegarAcceso(user)
        }
      },
      {
        text: 'Cancelar',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    console.log('onDidDismiss resolved with role and data', role, data);

  
  }
  darAcceso(i){
      this.db.collection('solicitud_usuario').get().subscribe(g=>{
        g.forEach(j=>{
          if(j.data()['numero']==i.numero){
              this.status=0
              this.crearUsuario(i) 
          }
        })
    })

  }
  crearUsuario(i){
    console.log(i)
    this.status=0
    this.useri=this.auth.auth.currentUser
    var cadena:string=i.numero.toString()
    this.auth.auth.createUserWithEmailAndPassword(i.email,cadena).then(g=>{
        this.db.collection('usuarios').doc(g.user.uid).set({
          apellido:i.apellido,
          datetime:i.datetime,
          email:i.email,
          pais:i.pais,
          estado:i.estado,
          nombre:i.nombre,
          numero:i.numero,
          role:i.role,
          type:i.type,
          oneSigID:i.oneSigID,
          telefono:i.celular,
          tokenSigID:i.tokenSigID,
          foto:i.foto,
          municipio:i.municipio,
          ciudad:i.ciudad,
          coords:i.coords,
          uid:g.user.uid
        }).then(()=>{
          this.auth.auth.updateCurrentUser(this.useri)
          var msg={
            title:"Haz Sido Aprobado!!",
            proveedor:g.user.uid,
            message:"Bienvenido al equipo MAXSELLGLOBAl!! Se ha Verificado Tú Solicitud"
          }
          console.log(msg)

           this.notification.sendNotiPushConfirmacionSolicitante(msg)
           this.db.collection('solicitud_usuario',ref=>ref.where('numero','==',i.numero)).get().subscribe(k=>{
                k.forEach(l=>{
                   l.ref.update({
                    estado:1
                   }).then(()=>{
                    
                      window.location.reload()
             
                    this.status=1
                  
                   })
                })
           })

        })
    })
  
  }
  denegarAcceso(i){
    this.db.collection('solicitud_usuario').get().subscribe(g=>{
      g.forEach(j=>{
        if(j.data()['numero']==i.numero){
          
          j.ref.delete().then(()=>{
             swal('Usuario Denegado','Denegado Correctamente','success')
             this.traerUsuariosSolicitantes()
          })
        }
      })
  })
  }
 
  clearPerfomRefresh(event){
    this.traerUsuariosSolicitantes()
    this.traerInformacionPersonal()
    this.traerInformacionTotalUsuarios()
    this.traerInformacionTotalPuntos()
    this.traerVentasTotales()
    this.pedidosEntrantes()
    this.traerDataUser()
    this.valorUnidades()
    setTimeout(() => {
  
      event.target.complete();
    }, 1000);
  }
  clearPerfom(){
    this.traerUsuariosSolicitantes()
    this.traerInformacionPersonal()
    this.traerInformacionTotalUsuarios()
    this.traerInformacionTotalPuntos()
    this.traerVentasTotales()
    this.pedidosEntrantes()
    this.traerDataUser()
    this.valorUnidades()
    
  }
  async toastMessage(){
    let toast = await this.tool.create({
      color:'success',
      message: 'Modificado Exitosamente',
      duration: 2000,
      position: 'bottom'
    })
    toast.present()

  }
  initMap(){ 
	  
    this.geo.initGeolocation().then(j=>{
		const mapEle: HTMLElement = document.getElementById('myMap');
	  const myLatLng = {lat:j.coords.latitude, lng:j.coords.longitude};
	  this.origin=myLatLng
	  // create map
	  this.map = new google.maps.Map(mapEle, {
		center:myLatLng,
		disableDefaultUI: false,
		
		zoom: 5
	  });
  /**/ 
  this.db.collection('seeds').get().subscribe(p=>{
	p.forEach(u=>{
		const contentString =
		'<div id="content">' +
		'<div id="siteNotice">' +
		"</div>" +
		'<h1 id="firstHeading" class="firstHeading">'+u.data()['nombreEstablecimiento']+'</h1>' +
		'<div id="bodyContent">' +
		'<span style="font-weight:bold;">Direccion:</span><p>'+u.data()['direccionEncargado']+'</p>'+
		'<span style="font-weight:bold;">Tipo Establecimiento:</span><p>'+u.data()['tipoEstablecimiento']+'</p>'+
		'<span style="font-weight:bold;">Encargado:</span><p>'+u.data()['nombreEncargado']+'</p>'+

		"</div>" +
		"</div>";
	  const infowindow = new google.maps.InfoWindow({
		content: contentString,
	  });
		var lans={lat:u.data()['coords'].lat, lng:u.data()['coords'].lng}
		var map=this.map
		var marker = new google.maps.Marker({
			position: lans,
		  
			title:u.data()['nombreEstablecimiento']
		  });
		  marker.addListener("click", () => {
            infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });
          });

		  marker.setMap(this.map)
      })
    })
 
	  google.maps.event.addListenerOnce(this.map, 'idle', () => {	   
		mapEle.classList.add('show-map');
	  });   
	})
  }

  async cambiarFoto(){
    const actionSheet = await this.actionSheetController.create({
      header: 'Opciones',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'Cambiar Foto',
        icon: 'checkmark',
        handler: () => {
          this.photo.tomarFoto()
          this.clearPerfom()
        }
      }, 
      
      {
        text: 'Cancelar',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    console.log('onDidDismiss resolved with role and data', role, data);
  }
}


